import { useState } from 'react';
import {
  countOrgsMatchingMode,
  DEFAULT_ORG_FILTER_MODE,
  OrgMenuFilterMode,
  resolveRolesTableOrgs,
} from './permissions-table-filter';
import { ShortOrgType } from './permissions-table.types';

export type RolesTableOrgCounts = Record<OrgMenuFilterMode, number>;

/**
 * The roles table's My / All / Hidden filter as one unit: the chosen mode
 * (opening on the shared default), whether the control is offered at all, the
 * rows to render, and the count each segment shows.
 *
 * Kept out of `user-details.tsx` because that page imports design-system Lit
 * elements and cannot be rendered by a unit test — the decisions below are what
 * Leo's review asked for (PSTUDIO-3330), so they need a test that runs them.
 */
export function useRolesTableOrgFilter({
  orgs,
  favoriteOrgIds,
  isCurrentUser,
}: {
  orgs: ShortOrgType[];
  favoriteOrgIds: string[] | undefined;
  isCurrentUser: boolean;
}) {
  const [mode, setMode] = useState<OrgMenuFilterMode>(DEFAULT_ORG_FILTER_MODE);

  const { showFilter, visibleOrgs } = resolveRolesTableOrgs({
    orgs,
    mode,
    favoriteOrgIds,
    isCurrentUser,
  });

  const counts: RolesTableOrgCounts = {
    my: countOrgsMatchingMode(orgs, 'my', favoriteOrgIds),
    all: orgs.length,
    hidden: countOrgsMatchingMode(orgs, 'hidden', favoriteOrgIds),
  };

  return { mode, setMode, showFilter, visibleOrgs, counts };
}
